export default __webpack_public_path__ + "static/media/md.54a3c39f.jpg";